module.exports = {
    title: 'contractsView-contractsView_precontractualConditionsTitle',
    order: 3,
    footer_text: '',
    position: 'middle',
    disableNext: 'deposittransfer_pollingNextButtonDisabled',
    on_next_click: 'deposittransfer_loadTermsAndConditionsLegalWindow',
	components: [
		{
			id_component: 'precontractual-conditions',
			id: 'precontractual-conditions',
            customCategoryEvent: 'deposittransfer_customCategoryEvent'
		},
        ...(
                __CONTACT_CENTER__ ?
                [{
                    id_component: 'legal-information',
                    legal_text: "mainDepositFlow-depositRetention_legalInformation",
                    customCategoryEvent: 'deposittransfer_customCategoryEvent',
                    isMandatoryRead: true,
                    readTextTitle: 'contractsView-legalInformation_readTextTitle',
                    readTextInfo: 'contractsView-legalInformation_readTextInfo',
                    getTextValues: 'deposittransfer_getStep3MandatoryReadDisclaimerText',
                }] : []
            )
	]
};